
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

import GasBills from '@/pages/gas/Bills';
import GasConsumers from '@/pages/gas/Consumers';
import GasReports from '@/pages/gas/Reports';
import GasKpiDashboard from '@/pages/gas/KpiDashboard';
import GasAnalytics from '@/pages/gas/Analytics';
import GasDeviceHealth from '@/pages/gas/DeviceHealth';

const gasRoutes = (
  <>
    <Route path="/gas/bills" element={
      <ProtectedRoute>
        <GasBills />
      </ProtectedRoute>
    } />
    <Route path="/gas/consumers" element={
      <ProtectedRoute>
        <GasConsumers />
      </ProtectedRoute>
    } />
    <Route path="/gas/reports" element={
      <ProtectedRoute>
        <GasReports />
      </ProtectedRoute>
    } />
    <Route path="/gas/dashboard" element={
      <ProtectedRoute>
        <GasKpiDashboard />
      </ProtectedRoute>
    } />
    <Route path="/gas/kpi-dashboard" element={
      <ProtectedRoute>
        <GasKpiDashboard />
      </ProtectedRoute>
    } />
    <Route path="/gas/analytics" element={
      <ProtectedRoute>
        <GasAnalytics />
      </ProtectedRoute>
    } />
    <Route path="/gas/device-health" element={
      <ProtectedRoute>
        <GasDeviceHealth />
      </ProtectedRoute>
    } />
  </>
);

export default gasRoutes;
